import { render, staticRenderFns } from "./VisiMisiSection.vue?vue&type=template&id=720298bc"
import script from "./VisiMisiSection.vue?vue&type=script&lang=js"
export * from "./VisiMisiSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports